"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BIObjectType = exports.BIAction = exports.BIEventType = void 0;
var BIEventType;
(function (BIEventType) {
    BIEventType["UserAction"] = "UserActionType";
    BIEventType["UiNavigation"] = "UiNavigationType";
    BIEventType["ErrorReport"] = "ErrorReportType";
    BIEventType["APIReport"] = "ApiReportType";
    BIEventType["SessionTags"] = "SessionTagsType";
    BIEventType["SessionStart"] = "SessionStartType";
    BIEventType["SpecialEvent"] = "SpecialType";
    BIEventType["StageReport"] = "StageReportType";
})(BIEventType || (exports.BIEventType = BIEventType = {}));
;
var BIAction;
(function (BIAction) {
    BIAction["Clicked"] = "Clicked";
})(BIAction || (exports.BIAction = BIAction = {}));
var BIObjectType;
(function (BIObjectType) {
    BIObjectType["Button"] = "Button";
    BIObjectType["Checkbox"] = "CheckBox";
    BIObjectType["Link"] = "Link";
})(BIObjectType || (exports.BIObjectType = BIObjectType = {}));
